import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './PhotoGallery.css'; // We'll create this CSS file next

interface ApiError {
  message: string;
  response?: {
    data?: {
      detail?: string | { msg: string }[];
    };
  };
}

const PhotoGallery: React.FC = () => {
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const extractErrorMessage = (err: ApiError): string => {
    if (err.response && err.response.data && err.response.data.detail) {
      const detail = err.response.data.detail;
      if (typeof detail === 'string') {
        return detail;
      } else if (Array.isArray(detail) && detail.length > 0 && detail[0].msg) {
        return detail[0].msg;
      }
    }
    return err.message || 'An unknown error occurred';
  };

  const fetchImages = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get<string[]>('/api/images');
      setImageUrls(response.data);
    } catch (err) {
      console.error('Error fetching images:', err);
      setError(extractErrorMessage(err as ApiError));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchImages();
  }, [fetchImages]);

  const openModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  if (loading) {
    return <div className="containerGallery"><p>Loading images...</p></div>;
  }

  if (error) {
    return <div className="container error-message"><p>Error loading images: {error}</p></div>;
  }

  return (
    <div className="containerGallery photo-gallery-container">
      <h2>Photo Gallery</h2>
      {imageUrls.length === 0 ? (
        <p>No images found.</p>
      ) : (
        <div className="image-grid">
          {imageUrls.map((url, index) => (
            <div key={index} className="image-item" onClick={() => openModal(url)}>
              <img src={url} alt={`Gallery image ${index + 1}`} />
            </div>
          ))}
        </div>
      )}

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={closeModal}>&times;</span>
            <img src={selectedImage} alt="Full size view" />
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;